import {
  ECustomRangeType,
  TAbsoluteTimeUnit,
  TRelativeTimeUnit, TSkipButtonTranslations,
} from '@/components/date-range-picker/date-range-picker.ts';

const timeUnits: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: 'Dátum',
  days: 'Deň | Dni',
  hours: 'Hodina | Hodiny',
  isoWeek: 'Kalendárny týždeň | Kalendárne týždne',
  minutes: 'Minúta | Minúty',
  months: 'Mesiac | Mesiace',
  quarters: 'Kvartál | Kvartály',
  weeks: 'Týždeň | Týždne',
  years: 'Rok | Roky',
};

const timeUnitsShort: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: '',
  days: 'D',
  hours: 'H',
  isoWeek: 'KT',
  minutes: 'min',
  months: 'M',
  quarters: 'Q',
  weeks: 't',
  years: 'r',
};

const header: Record<ECustomRangeType, string> = {
  [ECustomRangeType.ABSOLUTE]: 'Absolútny',
  [ECustomRangeType.CUSTOM]: 'Vlastný',
  [ECustomRangeType.RELATIVE]: 'Relatívny',
  [ECustomRangeType.BY_JOB]: 'Podla jobu',
};

const skipButtonTranslations: TSkipButtonTranslations = {
  next: 'Posunúť {formattedDuration} dopredu, na {to}',
  previous: 'Posunúť {formattedDuration} dozadu, na {to}',
};

const skipButtonTranslationsByJob: TSkipButtonTranslations = {
  next: 'Prejsť na ďalší job',
  previous: 'Prejsť na predchádzajúci job',
};

const directions: Record<'past' | 'future', string> = {
  past: 'Minulé',
  future: 'Nasledujúce',
};

export default {
  header,
  jobLabel: 'Job',
  lastJobLabel: 'Posledny job',
  useLastJob: 'Pouzit posledny job',
  convertToCustom: 'Konvertovať na vlastný',
  custom: 'Vlastný',
  currentWeek: 'aktuálny týždeň',
  previousWeek: 'minulý týždeň',
  nextWeek: 'budúci týždeň',
  calendarWeek: 'KT',
  rangeInvalidHint: 'Vybrané obdobie je dlhšie ako maximálne povolené trvanie {maxDuration} alebo vybrané dátumy presahujú povolený rozsah {minDate} - {maxDate}.',
  rangeFrom: 'Od',
  rangeTo: 'Do',
  timeUnit: 'Časová jednotka',
  all: 'Všetko',
  timeUnits,
  timeUnitsShort,
  skipButtonTranslations,
  skipButtonTranslationsByJob,
  directions,
};
